import React from "react";
import { Link } from "react-router-dom";

const baseClassName =
  "card border-round-lg p-4 flex flex-column justify-content-center align-items-center gap-3 text-decoration-none cursor-pointer";

const baseStyle = {
  minWidth: "140px",
  maxWidth: "190px",
  border: "1px solid var(--theme-border, #EBEBEB)",
  color: "inherit",
};

const QuickAccessCard = ({ to, onClick, icon, label }) => {
  const inner = (
    <>
      <div
        className="flex align-items-center justify-content-center p-4"
        style={{
          width: "40px",
          height: "40px",
          border: "1px solid var(--theme-border, #EBEBEB)",
          borderRadius: "50%",
        }}
      >
        <i
          className={`${icon} text-md font-bold`}
          style={{ color: "var(--theme-text, #171717)" }}
        />
      </div>
      <div className="text-center">
        <span className="font-medium text-center">{label}</span>
      </div>
    </>
  );

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={`${baseClassName}`}
        style={{
          ...baseStyle,
          background: "var(--surface-card, #ffffff)",
          font: "inherit",
          textAlign: "center",
        }}
      >
        {inner}
      </button>
    );
  }

  return (
    <Link to={to} className={baseClassName} style={baseStyle}>
      {inner}
    </Link>
  );
};

export default QuickAccessCard;
